__webpack_require__.p = "/realtime-chat-platform/";